<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <BreadCrumd
          :title="'Planification'"
          :description="'Nouvelle planification'"
        />
      </div>
      <div class="col-md-6 mt-4">
        <div class="row" v-if="chantier">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex">
                  <td class="col-12 text-center font-weight-bold">
                    Chantier concerné
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12 d-flex justify-content-between px-2">
                    <span>Nom :</span><span>{{ chantier.nom }}</span>
                  </td>
                </tr>

                <!-- <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12 d-flex justify-content-between px-2">
                    <span>Type :</span><span>{{ chantier.type }}</span>
                  </td>
                </tr> -->
              </tbody>
            </table>
          </div>
        </div>
        <b-alert
          :show="form.errors.has('chantier')"
          dismissible
          variant="danger"
          class="mt-1"
        >
          <span v-html="form.errors.get('chantier')"></span>
        </b-alert>
      </div>
    </div>

    <planning-form
      :propForm="form"
      @submit="submit"
      @list="goList"
      :horaires="horaires"
      :employes="employes"
    />
  </div>
</template>

<script>
import URL from '@/http/planning';
import CHANTIER_URL from '@/http/chantier';
import PlanningForm from '../PlanningForm.vue';
import names from '@/constants/routes/chantier/chantier';
import { objectToFormData } from 'object-to-formdata';

import From from 'vform';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: new From({
        date_debut: this.$options.filters.formatDate(new Date(), 'DD/MM/YYYY'),
        commentaire: '',
        horaire: null,
      }),
      chantier: null,
      routes: names,
      horaires: [],
      employes: [],
    };
  },
  components: {
    PlanningForm,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  computed: {
    ...mapGetters('chantier', ['currentChantier']),
  },
  methods: {
    ...mapActions('chantier', ['setCurrentChantier']),
    init() {
      this.id = this.$route.params.id;

      window.axios
        .all([window.axios.get(CHANTIER_URL.CHANTIER + '/' + this.id)])
        .then(
          window.axios.spread((resp) => {
            let data = resp.data.chantier;
            this.chantier = {
              ...data,
            };
            window.axios
              .get(URL.GET_REQUIREMENTS, {
                params: {
                  chantier: this.chantier.uuid,
                },
              })
              .then((resp2) => {
                this.horaires = resp2.data.horaires;
                this.employes = resp2.data.employes;
                this.form.horaire = resp2.data.default_horaire;
              });
          })
        )
        .catch();
    },
    submit(form) {
      this.form.chantier = this.chantier.uuid;
      const options = {
        nullsAsUndefineds: true,
      };
      form
        .post(URL.PLANNING, {
          transformRequest: [
            function (data) {
              return objectToFormData(data, options);
            },
          ],
        })
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          form.reset();
          form.clear();

          this.$router.push({
            name: this.routes.showPlanning,
            params: { id: this.chantier.id },
          });
        })
        .catch((err) => {
          form.errors.set('message', err.response.data.message);
        })
        .finally(() => {
          this.form = form;
        });
    },

    goList() {
      this.$router.push({
        name: this.routes.showPlanning,
        params: { id: this.chantier.id },
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
